export default "__VITE_ASSET__XivDCLKvo3rsiwL$eU0pkA__";